import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'forsikringsmaegler';
            break;

        case 'forsikringsmaegler':
            nextPage = 'om-virksomheden';
            break;

        case 'om-virksomheden':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
